import moment from "moment-timezone";

/**
 * 区域设置 value（如 zh_CN）→ ISO 3166-1 alpha-2，与字典 CountryEnum 常见项对齐
 */
const LOCALE_VALUE_TO_COUNTRY = {
  zh_CN: "CN",
  hi_IN: "IN",
  th_TH: "TH",
  pt_br: "BR",
  pt_BR: "BR",
};

/**
 * 首都/中央政府所在地常用 IANA 时区。
 * 一国多时区（如 CN、BR）不能仅靠 moment.tz.zonesForCountry 推断首都，需显式表。
 */
const CAPITAL_TIMEZONE_BY_COUNTRY = {
  CN: "Asia/Shanghai",
  IN: "Asia/Kolkata",
  TH: "Asia/Bangkok",
  BR: "America/Sao_Paulo",
};

/**
 * @param {string} countryCode ISO 3166-1 alpha-2，如 CN、BR
 * @returns {string} IANA 时区名，无法解析时返回 ''
 */
export function getCapitalTimezoneForCountry(countryCode) {
  if (!countryCode || typeof countryCode !== "string") {
    return "";
  }
  const code = countryCode.trim().toUpperCase();
  if (CAPITAL_TIMEZONE_BY_COUNTRY[code]) {
    return CAPITAL_TIMEZONE_BY_COUNTRY[code];
  }
  try {
    const zones = moment.tz.zonesForCountry(code);
    if (Array.isArray(zones) && zones.length === 1) {
      return zones[0];
    }
  } catch (e) {
    // 无效国家代码
  }
  return "";
}

/**
 * 根据字典项（含 code 或仅有 value 区域设置）解析首都常用 IANA 时区
 * @param {{ code?: string, value?: string }} item
 * @returns {string}
 */
export function getCapitalTimezoneFromCountryItem(item) {
  if (!item) return "";
  const rawCode = item.code != null ? String(item.code).trim() : "";
  if (rawCode) {
    return getCapitalTimezoneForCountry(rawCode);
  }
  const mapped =
    item.value != null && LOCALE_VALUE_TO_COUNTRY[String(item.value).trim()];
  return mapped ? getCapitalTimezoneForCountry(mapped) : "";
}
